module.exports = __webpack_public_path__ + "img/xhd-logo.3849948e.png";